// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messages-container {
  display: flex;
  flex-direction: column;
}

.message-card {
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  background-color: white;
  margin-bottom: 1rem;
}
.message-card__inner {
  display: flex;
  gap: 1rem;
  max-height: 400px;
}

.advert-summary {
  flex: 0 0 400px;
  max-height: 400px;
  overflow: hidden;
}
.advert-summary .card {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  background-color: white;
}
.advert-summary .vehicle-image {
  position: relative;
  flex-shrink: 0;
}
.advert-summary .vehicle-image img {
  width: 100%;
  max-height: 100px;
  border-radius: 0.375rem 0.375rem 0 0;
  object-fit: cover;
}

.listing-type {
  width: 100%;
  text-align: center;
  padding: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: white;
  background-color: #1e293b;
  border-radius: 0 0 0.375rem 0.375rem;
}
.listing-type--1 {
  background-color: #1e293b;
}
.listing-type--2 {
  background-color: #334155;
}

.vehicle-details h3 {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 0.25rem 0;
}
.vehicle-details .vehicle-reg {
  color: #64748b;
  font-size: 0.75rem;
  margin: 0;
}

.card-body {
  flex: 1;
  overflow-y: auto;
}

.advert-time {
  color: #64748b;
  font-size: 0.75rem;
}
.advert-time .date {
  font-weight: 500;
  color: #1e293b;
}
.advert-time .time {
  font-size: 0.8125rem;
}

.advert-vendor {
  font-size: 0.75rem;
}
.advert-vendor .label {
  color: #64748b;
}
.advert-vendor .vendor-contact {
  display: flex;
  flex-direction: column;
}
.advert-vendor .vendor-contact span:not(.label) {
  color: #1e293b;
}
.advert-vendor .vendor-contact .vendor-email {
  color: #3b82f6;
}

.message-threads {
  flex: 1;
  display: flex;
  max-height: 400px;
}
.message-threads .threads-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0 !important;
  background-color: white;
}

.message-thread {
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
}
.message-thread:last-child {
  margin-bottom: 0;
}
.message-thread.needs-attention {
  border-top: 2px solid #dc2626;
}

.thread-content {
  display: flex;
  flex-direction: row;
  flex: 1;
}

.enquirer-info {
  padding: 5px 8px !important;
  background-color: #4e658c !important;
  border-radius: 0.375rem;
}
.enquirer-info h5 {
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
}

.messages-list {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  padding-right: 2px;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
}

.message {
  padding: 5px !important;
  border: 1px solid #e2e8f0;
  border-radius: 0 !important;
  transition: background-color 0.2s ease;
  border-left: 3px solid rgba(51, 51, 51, 0.5019607843);
}
.message.unread {
  background-color: white !important;
  border-left: 3px solid #dc2626;
}
.message.reply {
  background-color: white;
}
.message.not-reply {
  background-color: #f8f9fa;
}
.message:last-child {
  margin-bottom: 0;
}
.message .message-header {
  color: #64748b;
  font-size: 0.875rem;
}
.message .message-content {
  line-height: 1.5;
  font-weight: 600;
  font-size: 0.875rem;
  white-space: pre-wrap;
}
.message .message-actions {
  margin-top: 1rem;
}

.reply-box {
  flex-grow: 1;
  max-width: 400px;
  padding: 8px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
}
.reply-box textarea {
  width: 100%;
  resize: vertical;
  min-height: 80px;
}

.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
}
.pagination-container select {
  margin-left: 0.5rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
}

.badge {
  margin-left: 10px;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  border-radius: 9999px;
}
.badge.bg-danger {
  background-color: #dc2626;
  color: white;
}

.blue-white-switch {
  display: flex;
  align-items: center;
}
.blue-white-switch .switch-label {
  color: #64748b;
  font-size: 0.875rem;
  margin-right: 0.5rem;
}

.nav-tabs {
  border-bottom: 1px solid #e2e8f0;
}
.nav-tabs .nav-link {
  padding: 0.25rem 1rem;
  cursor: pointer;
  font-size: 0.75rem;
}
.nav-tabs .nav-link.needs-attention {
  border-top: 2px solid #dc2626;
}

.tab-content {
  height: 200px;
  overflow-y: hidden;
}

.tab-pane {
  height: 100%;
  display: none;
  overflow-y: auto;
}
.tab-pane.active {
  display: flex;
  flex-direction: column;
}

.messages-list {
  flex: 1;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/admin/admin-messages-to-sellers/admin-messages-to-sellers.component.scss"],"names":[],"mappings":"AAaA;EACE,aAAA;EACA,sBAAA;AAZF;;AAgBA;EACE,yBAAA;EACA,uBApBc;EAqBd,uBAAA;EACA,mBAfa;AAEf;AAeE;EACE,aAAA;EACA,SAnBW;EAoBX,iBAlBY;AAKhB;;AAkBA;EACE,eAAA;EACA,iBAzBc;EA0Bd,gBAAA;AAfF;AAiBE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBA1CY;EA2CZ,uBAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,cAAA;AAhBJ;AAkBI;EACE,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,iBAAA;AAhBN;;AAqBA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBA5DU;EA6DV,oCAAA;AAlBF;AAoBE;EAAO,yBAAA;AAjBT;AAkBE;EAAO,yBAAA;AAfT;;AAmBE;EACE,eAAA;EACA,gBAAA;EACA,cAvEQ;EAwER,qBAAA;AAhBJ;AAmBE;EACE,cA7EQ;EA8ER,kBAAA;EACA,SAAA;AAjBJ;;AAqBA;EACE,OAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,cAzFU;EA0FV,kBAAA;AAlBF;AAoBE;EACE,gBAAA;EACA,cA7FQ;AA2EZ;AAqBE;EACE,oBAAA;AAnBJ;;AAuBA;EACE,kBAAA;AApBF;AAsBE;EACE,cA1GQ;AAsFZ;AAuBE;EACE,aAAA;EACA,sBAAA;AArBJ;AAuBI;EACE,cAjHM;AA4FZ;AAwBI;EACE,cA1HS;AAoGf;;AA4BA;EACE,OAAA;EACA,aAAA;EACA,iBA3Hc;AAkGhB;AA2BE;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;AAzBJ;;AA6BA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;AA1BF;AA4BE;EACE,gBAAA;AA1BJ;AA6BE;EACE,6BAAA;AA3BJ;;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;AA5BF;;AA+BA;EACE,2BAAA;EACA,oCAAA;EACA,uBAvKc;AA2IhB;AA8BE;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;AA5BJ;;AAgCA;EACE,OAAA;EAEA,YAAA;EACA,gBAAA;EACA,kBAAA;EAEA,yBAAA;EACA,uBAxLc;AAyJhB;;AAkCA;EACE,uBAAA;EAEA,yBAAA;EACA,2BAAA;EACA,sCAAA;EAEA,qDAAA;AAjCF;AAmCE;EACE,kCAAA;EACA,8BAAA;AAjCJ;AAoCE;EACE,uBAAA;AAlCJ;AAqCE;EACE,yBAAA;AAnCJ;AAuCE;EACE,gBAAA;AArCJ;AAwCE;EACE,cAlNQ;EAmNR,mBAAA;AAtCJ;AAyCE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AAvCJ;AA0CE;EACE,gBA5NW;AAoLf;;AA4CA;EACE,YAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAvOQ;EAwOR,yBAAA;EACA,uBA7Oc;AAoMhB;AA2CE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AAzCJ;;AA8CA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aApPa;EAqPb,uBAAA;EACA,yBAAA;EACA,uBA9Pc;AAmNhB;AA6CE;EACE,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBApQY;AAyNhB;;AAgDA;EACE,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;AA7CF;AA+CE;EACE,yBA9QU;EA+QV,YAAA;AA7CJ;;AAiDA;EACE,aAAA;EACA,mBAAA;AA9CF;AAgDE;EACE,cArRQ;EAsRR,mBAAA;EACA,oBAAA;AA9CJ;;AAkDA;EACE,gCAAA;AA/CF;AAiDE;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;AA/CJ;AAiDI;EACE,6BAAA;AA/CN;;AAoDA;EACE,aAAA;EACA,kBAAA;AAjDF;;AAoDA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;AAjDF;AAmDE;EACE,aAAA;EACA,sBAAA;AAjDJ;;AAqDA;EACE,OAAA;EACA,gBAAA;AAlDF","sourcesContent":["// Variables\n$border-radius: 0.375rem;\n$primary-blue: #3b82f6;\n$primary-red: #dc2626;\n$border-gray: #e2e8f0;\n$bg-gray: #f8fafc;\n$text-gray: #64748b;\n$text-dark: #1e293b;\n$spacing-base: 1rem;\n$transition-base: 0.2s ease;\n$advert-height: 400px;\n\n// Main container\n.messages-container {\n  display: flex;\n  flex-direction: column;\n}\n\n// Message card\n.message-card {\n  border: 1px solid $border-gray;\n  border-radius: $border-radius;\n  background-color: white;\n  margin-bottom: $spacing-base;\n\n  &__inner {\n    display: flex;\n    gap: $spacing-base;\n    max-height: $advert-height;\n  }\n}\n\n// Advert summary\n.advert-summary {\n  flex: 0 0 $advert-height;\n  max-height: $advert-height;\n  overflow: hidden;\n\n  .card {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid $border-gray;\n    border-radius: $border-radius;\n    background-color: white;\n  }\n\n  .vehicle-image {\n    position: relative;\n    flex-shrink: 0;\n\n    img {\n      width: 100%;\n      max-height: 100px;\n      border-radius: $border-radius $border-radius 0 0;\n      object-fit: cover;\n    }\n  }\n}\n\n.listing-type {\n  width: 100%;\n  text-align: center;\n  padding: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: white;\n  background-color: $text-dark;\n  border-radius: 0 0 $border-radius $border-radius;\n\n  &--1 { background-color: #1e293b; }\n  &--2 { background-color: #334155; }\n}\n\n.vehicle-details {\n  h3 {\n    font-size: 1rem;\n    font-weight: 600;\n    color: $text-dark;\n    margin: 0 0 0.25rem 0;\n  }\n\n  .vehicle-reg {\n    color: $text-gray;\n    font-size: 0.75rem;\n    margin: 0;\n  }\n}\n\n.card-body {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.advert-time {\n  color: $text-gray;\n  font-size: 0.75rem;\n\n  .date {\n    font-weight: 500;\n    color: $text-dark;\n  }\n\n  .time {\n    font-size: 0.8125rem;\n  }\n}\n\n.advert-vendor {\n  font-size: 0.75rem;\n\n  .label {\n    color: $text-gray;\n  }\n\n  .vendor-contact {\n    display: flex;\n    flex-direction: column;\n\n    span:not(.label) {\n      color: $text-dark;\n    }\n\n    .vendor-email {\n      color: $primary-blue;\n    }\n  }\n}\n\n// Message threads\n.message-threads {\n  flex: 1;\n  display: flex;\n  max-height: $advert-height;\n\n  .threads-container {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    padding: 0 !important;\n    background-color: white;\n  }\n}\n\n.message-thread {\n  margin-bottom: $spacing-base * 2;\n  display: flex;\n  flex-direction: column;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &.needs-attention {\n    border-top: 2px solid $primary-red;\n  }\n}\n\n.thread-content {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n}\n\n.enquirer-info {\n  padding: 5px 8px !important;\n  background-color: #4e658c !important;\n  border-radius: $border-radius;\n\n  h5 {\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: white;\n  }\n}\n\n.messages-list {\n  flex: 1;\n  //max-height: 250px;\n  height: 100%;\n  overflow-y: auto;\n  padding-right: 2px;\n  //margin-bottom: $spacing-base;\n  border: 1px solid $border-gray;\n  border-radius: $border-radius;\n}\n\n.message {\n  padding: 5px !important;\n  //margin-bottom: 5px;\n  border: 1px solid $border-gray;\n  border-radius: 0 !important;\n  transition: background-color $transition-base;\n\n  border-left: 3px solid #33333380;\n\n  &.unread {\n    background-color: white !important;\n    border-left: 3px solid $primary-red;\n  }\n\n  &.reply {\n    background-color: white;\n  }\n\n  &.not-reply {\n    background-color: #f8f9fa;\n  }\n\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  .message-header {\n    color: $text-gray;\n    font-size: 0.875rem;\n  }\n\n  .message-content {\n    line-height: 1.5;\n    font-weight: 600;\n    font-size: 0.875rem;\n    white-space: pre-wrap;\n  }\n\n  .message-actions {\n    margin-top: $spacing-base;\n  }\n}\n\n.reply-box {\n  flex-grow: 1;\n  max-width: 400px;\n  padding: 8px;\n  background-color: $bg-gray;\n  border: 1px solid $border-gray;\n  border-radius: $border-radius;\n\n  textarea {\n    width: 100%;\n    resize: vertical;\n    min-height: 80px;\n  }\n}\n\n// Pagination\n.pagination-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: $spacing-base;\n  background-color: white;\n  border: 1px solid $border-gray;\n  border-radius: $border-radius;\n\n  select {\n    margin-left: 0.5rem;\n    padding: 0.25rem 0.5rem;\n    border: 1px solid $border-gray;\n    border-radius: $border-radius;\n  }\n}\n\n// Utilities\n.badge {\n  margin-left: 10px;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  border-radius: 9999px;\n\n  &.bg-danger {\n    background-color: $primary-red;\n    color: white;\n  }\n}\n\n.blue-white-switch {\n  display: flex;\n  align-items: center;\n\n  .switch-label {\n    color: $text-gray;\n    font-size: 0.875rem;\n    margin-right: 0.5rem;\n  }\n}\n\n.nav-tabs {\n  border-bottom: 1px solid $border-gray;\n\n  .nav-link {\n    padding: 0.25rem 1rem;\n    cursor: pointer;\n    font-size: 0.75rem;\n\n    &.needs-attention {\n      border-top: 2px solid $primary-red;\n    }\n  }\n}\n\n.tab-content {\n  height: 200px;\n  overflow-y: hidden;\n}\n\n.tab-pane {\n  height: 100%;\n  display: none;\n  overflow-y: auto;\n\n  &.active {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.messages-list {\n  flex: 1;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
